export const WORKFLOW_SEARCH = 'workflow/search';
 export const workflowSearch = (data) => ({
   type: WORKFLOW_SEARCH,
   payload: data
 });

export const WORKFLOW_SEARCH_ON_SUCCESS = 'workflow/searchOnSuccess';
 export const workflowSearchOnSuccess = (data) => ({
   type: WORKFLOW_SEARCH_ON_SUCCESS,
   payload: data
 });

 export const WORKFLOW_SEARCH_ON_FAIL = 'workflow/searchOnFail';
 export const workflowSearchOnFail = (error) => ({
   type: WORKFLOW_SEARCH_ON_FAIL,
   payload: error
 });